import { render, staticRenderFns } from "./NetworkFlatAgeTable.vue?vue&type=template&id=2b72a9e6"
import script from "./NetworkFlatAgeTable.vue?vue&type=script&lang=js"
export * from "./NetworkFlatAgeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports